import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class AboutV6 extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'
        let imagealt = 'image'

    return <section className="about-three about-three__about-page  go-top">
			  <div className="container">
			    <div className="row">
			      <div className="col-xl-6">
			        <div className="about-three__content">
			          <div className="block-title-two text-left">
			            <p>What we do</p>
			            <h3>Automate support and  <br/> maximize conversions effortlessly.</h3>
			          </div>{/* /.block-title-two */}
			          <p>We provide intelligent conversational and voice solutions designed to help businesses automate customer engagement, capture more leads, and deliver instant support 24/7.</p>
			          <p>Our platform combines intelligent text-based conversations with human-like voice interactions, enabling businesses to connect with their audience seamlessly across multiple touchpoints</p>
			          <h4>Started With Us</h4>
			          <p>Smarter Technology. Safer Design. Seamless Experience. Converzex is not just an automation tool; it’s your intelligent growth partner.</p>
			          {/*<Link to="/service-details" className="thm-btn about-three__btn">Read More <i className="fa fa-angle-double-right" /></Link>*/}
			          {/* /.thm-btn about-three__btn */}
			        </div>{/* /.about-three__content */}
			      </div>{/* /.col-lg-6 */}
			      <div className="col-xl-6 d-flex justify-content-center">
			        <div className="video-one__box">
			          <img src={publicUrl+"assets/images/resources/video-bg-new.jpg"} alt={ imagealt } />
			          <a href="#" className="video-popup video-one__btn"><i className="fa fa-play" /></a>{/* /.video-popup video-one__btn */}
			        </div>{/* /.video-one__box */}
			      </div>{/* /.col-lg-6 */}
			    </div>{/* /.row */}
			  </div>{/* /.container */}
			</section>
        }
}

export default AboutV6